import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs';
import { IncidentsActions } from '../state/incidents/incidents.action-types';
import { IncidentsService } from '../../services/incidents.service';
import { IncidentModels } from '../../models/incident.model';

export const loadIncidents$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(IncidentsActions.loadIncidents),
      switchMap(({ request, append }) => [
        IncidentsActions.setIsLoading({ isLoading: true }),
        IncidentsActions.loadIncidentsRequest({ request, append }),
      ]),
    ),
  { functional: true },
);

export const loadIncidentsRequest$ = createEffect(
  (
    actions$ = inject(Actions),
    incidentsService = inject(IncidentsService),
  ) =>
    actions$.pipe(
      ofType(IncidentsActions.loadIncidentsRequest),
      switchMap(({ request, append }) =>
        incidentsService.searchIncidents(request).pipe(
          switchMap((response) => [
            IncidentsActions.setIsLoading({ isLoading: false }),
            IncidentsActions.loadIncidentsSuccess({ response, append }),
          ]),
          catchError(() => [
            IncidentsActions.setIsLoading({ isLoading: false }),
          ]),
        ),
      ),
    ),
  { functional: true },
);

export const loadPanicAlerts$ = createEffect(
  (
    actions$ = inject(Actions),
    incidentsService = inject(IncidentsService),
  ) =>
    actions$.pipe(
      ofType(IncidentsActions.loadPanicAlerts),
      switchMap(({ accountId }) =>
        incidentsService.getPanicAlerts(accountId).pipe(
          map((alerts) => {
            const coords: Record<string, { lat: number; lng: number } | null> = {};
            alerts.forEach((a) => {
              coords[String(a.alertInstanceId)] = IncidentModels.Panic.parseCoords(a.extra?.event_fields ?? null);
            });
            return IncidentsActions.loadPanicAlertsSuccess({ accountId, coords });
          }),
          catchError(() => [IncidentsActions.loadPanicAlertsFail({ accountId })]),
        ),
      ),
    ),
  { functional: true },
);